import { loadPartnerLevelAccounts } from './switch-accounts.actions';
import {
  trackSwitchAccountsRequests,
  updateCustomerAccounts,
  updatePartnerAccounts,
} from './switch-accounts.repository';
import { groupAccounts } from '../utils/group-accounts';
import { sortAccounts } from '../utils/sort-accounts';
import { toDropdownOptions } from '../utils/to-dropdown-options';
import {
  createEffect,
  ofType,
  registerEffects,
  removeEffects,
  tapResult,
} from '@ngneat/effects';
import { switchMap } from 'rxjs';
import { emitOnce } from '@ngneat/elf';
import { AuthwsApi } from '@tmx/data-access';
import { getCurrentAuthData } from '@tmx/auth';

const loadPartnerLevelAccounts$ = createEffect((actions) =>
  actions.pipe(
    ofType(loadPartnerLevelAccounts),
    switchMap(() =>
      AuthwsApi.getPartnerAccounts({
        applicationName: getCurrentAuthData().trimbleMapsAppName,
      }).pipe(
        trackSwitchAccountsRequests(['fetch-accounts']),
        sortAccounts(),
        groupAccounts(),
        toDropdownOptions()
      )
    ),
    tapResult(({ partnerAccounts, customerAccounts }) => {
      emitOnce(() => {
        updatePartnerAccounts(partnerAccounts);
        updateCustomerAccounts(customerAccounts);
      });
    })
  )
);

const effects = [loadPartnerLevelAccounts$];

export function registerSwitchAccountsEffects() {
  registerEffects(effects);
}

export function deregisterSwitchAccountsEffects() {
  removeEffects(effects);
}
